


































































































import {
  EventSceneManagementEventImageDTO,
  EventSceneManagementEventSceneService as eventScene,
} from "@/common/api";
import { EventSceneManagementEventSceneDTO } from "@/common/api/models/EventSceneManagementEventSceneDTO";
import QErrors from "@/common/qErrors.vue";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatImageUrl } from "@/common/utils";
import {
  quantities,
  QuantitieValues,
  sceneTypes,
} from "@/components/admin/eventRemote/eventRemoteType";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import EventRemoteUploadImageComponent from "./eventRemoteUploadImageComponent.vue";

@Component({
  name: "EventRemoteSettingComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    QMultiSelect,
    QUploadSingleImage,
    QErrors,
    EventRemoteUploadImageComponent,
  },
})
export default class EventRemoteSettingComponent extends Vue {
  get isYokyoMode() {
    return this.localSetting.type === "yokyo";
  }

  get quantityOptions() {
    return [
      { text: "1", value: quantities.one },
      { text: "5", value: quantities.five },
      { text: "10", value: quantities.ten },
      { text: "50", value: quantities.fifty },
      { text: "すべて", value: quantities.all },
    ];
  }
  @Prop({ required: true })
  public readonly eventScene!: EventSceneManagementEventSceneDTO;
  @Prop({ required: true })
  public readonly canChangeSetting: boolean;
  @Prop({ required: false })
  public readonly error: string | null;

  public localSetting = {
    requestQuantity: null as QuantitieValues,
    isApplyQuantityToNext: false,
    type: "",
    selectedEventImageId: null,
    images: [],
  };

  public sceneTypes = sceneTypes;
  public quantities = quantities;
  public isLoading = false;

  public uploading = false;
  public errors = {};

  @Watch("eventScene", { immediate: true, deep: true })
  public onEventSceneChanged(newEventScene) {
    const _images = newEventScene.event_images.map((eventImage) => {
      return {
        id: eventImage.image_id,
        eventImageId: eventImage.id,
        src: formatImageUrl(eventImage.image_name, "300x300"),
      };
    });

    const setting = {
      requestQuantity: newEventScene.quantity as QuantitieValues,
      isApplyQuantityToNext: false,
      type: newEventScene.type,
      selectedEventImageId: newEventScene.event_image_id,
      images: _images,
    };
    this.localSetting = setting;
  }

  @Watch("localSetting", { immediate: true, deep: true })
  public onLocalSettingChanged(newLocalSetting) {
    if (newLocalSetting.requestQuantity !== quantities.one) {
      this.localSetting.type = sceneTypes.正札モード;
    }
    if (newLocalSetting.type !== "yokyo") {
      this.localSetting.selectedEventImageId = null;
    }
  }

  @Emit("save-settings")
  public saveSetting() {
    if (!this.eventScene.exist_next) {
      this.localSetting.isApplyQuantityToNext = false;
    }
    return this.localSetting;
  }

  public uploadStatus(flag: boolean): void {
    this.uploading = flag;
  }

  public selectImage(image) {
    if (this.localSetting.type !== "yokyo") {
      return;
    }
    const newLocalSetting = {
      ...this.localSetting,
      images: this.localSetting.images,
      selectedEventImageId: image.eventImageId,
    };
    this.localSetting = newLocalSetting;
  }

  @Emit("uploaded-event-image")
  public uploadedEventImage(eventImage: EventSceneManagementEventImageDTO) {
    this.localSetting.images.push({
      id: eventImage.image_id,
      eventImageId: eventImage.id,
      src: formatImageUrl(eventImage.image_name, "300x300"),
    });

    const newLocalSetting = {
      ...this.localSetting,
      images: this.localSetting.images,
      selectedEventImageId:
        this.localSetting.type === "yokyo" ? eventImage.id : null,
    };
    this.localSetting = newLocalSetting;

    return eventImage.id;
  }
  public close() {
    const checkbox = this.$refs.settingOpenRef as HTMLInputElement;
    if (checkbox.checked) {
      checkbox?.click();
    }
  }
  public uploadImage() {
    const uploadBtn = this.$refs
      .EventRemoteUploadImageComponentRef as EventRemoteUploadImageComponent;
    uploadBtn?.open();
  }

  public async deleteEventImage(dletedEventImageId: number) {
    const images = this.localSetting.images.filter(
      (_image) => _image.eventImageId !== dletedEventImageId,
    );
    const isSelectedImage =
      this.localSetting.selectedEventImageId === dletedEventImageId;
    const newLocalSetting = {
      ...this.localSetting,
      images,
      selectedEventImageId: isSelectedImage
        ? null
        : this.localSetting.selectedEventImageId,
    };
    this.localSetting = newLocalSetting;
  }

  @Emit("upload-event-image-cancel")
  public handleCancel() {}
}
